import {SmartLibraryApplication} from "./enums/smart-library-application.enum";
import {ConfigDto} from "./config.dto";
import {ConfigLevel} from "./interfaces/config-level";
import {TreeNode} from "./interfaces/tree-node";
import {ConfigLevelType} from "./enums/config-level-type.enum";
import {Serialisable} from "../serialisable";

export class ApplicationDto extends Serialisable implements TreeNode {
    id: number;
    terminalId: number;
    configGroupId: number;

    version: string;
    application: SmartLibraryApplication;
    heartbeatDateUtc: Date;

    configLevel = ConfigLevelType.Application;
    getChildren(): ConfigLevel[] {
        return [];
    }
    setChildren(value: ApplicationDto[]): void {
        // intentionally omitted
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/application.dto.ts